import { render, staticRenderFns } from "./TenantDetail.vue?vue&type=template&id=e9d1c76e&"
import script from "./TenantDetail.vue?vue&type=script&lang=js&"
export * from "./TenantDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports